import React, { Component } from "react";

import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import StringUtil from "../../../actions/string";

import CadastroEndereco from "./CadastroEndereco";
import CadastroObservacao from "./CadastroObservacao";

class CadastroEmpresa extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    if (this.props.match.params.id) {
      this.state.id = this.props.match.params.id;
    }

    this.getInitialState = this.getInitialState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeEndereco = this.handleChangeEndereco.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      razaoSocial: "",
      nomeFantasia: "",
      cnpj: "M",
      email: "",
      telefoneCelular: "",
      telefoneComercial: "",
      endereco: {
        id: 0,
        estado: "",
        cidade: "",
        logradouro: "",
        numero: "",
        cep: "",
        bairro: "",
        complemento: "",
        pontoReferencia: ""
      },
      observacoes: "",
      inativo: false
    };
  }

  // Hack para atualizar a pagina quando estiver nessa rota
  componentWillReceiveProps() {
    window.scrollTo(0, 0);
    this.setState(this.getInitialState());
  }

  componentDidMount() {
    UI.inputHelpers();

    // Verifica se vem de uma rota com id
    let id = parseInt(this.state.id)
    if (id !== 0) {
      UI.loader("show", "Um momento...");
      API.get("/empresas/" + this.state.id)
        .then(
          function (json) {
            UI.loader("hide");
            this.setState(json.data);
          }.bind(this)
        )
        .catch(
          function (json) {
            UI.loader("hide");
            UI.alert(false, json.message);
          }
        );
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    let data = this.state;

    // Preparar dados para envio
    data.cnpj = StringUtil.unmask(data.cnpj);
    data.telefoneComercial = StringUtil.unmask(data.telefoneComercial);
    data.telefoneCelular = StringUtil.unmask(data.telefoneCelular);
    data.endereco.cep = StringUtil.unmask(data.endereco.cep);

    // Chamada da API
    UI.loader("show", "Um momento...");
    API.post("/empresas", data)
      .then(function (json) {
        if (json.success) {
          this.props.onUpdate(json.data);
          this.setState(json.data);
        }
        UI.alert(json.success, json.message);
        UI.loader("hide");
      }.bind(this))
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeEndereco(event) {
    let endereco = this.state.endereco;
    endereco[event.target.name] = event.target.value;
    this.setState({ endereco: endereco });
  }

  handleChecked(event) {
    this.setState({ [event.target.name]: event.target.checked });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">CADASTRO EMPRESA</h4>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Razão Social *</label>
                    <input
                      placeholder="RAZÃO SOCIAL"
                      autoFocus
                      name="razaoSocial"
                      type="text"
                      className="form-control"
                      value={this.state.razaoSocial}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label>Nome Fantasia *</label>
                    <input
                      placeholder="NOME FANTASIA"
                      autoFocus
                      name="nomeFantasia"
                      type="text"
                      className="form-control"
                      value={this.state.nomeFantasia}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>CNPJ *</label>
                    <InputMask
                      placeholder="CNPJ"
                      name="cnpj"
                      className="form-control"
                      mask="99.999.999/9999-99"
                      value={this.state.cnpj}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Telefone Comercial</label>
                    <InputMask
                      placeholder="TELEFONE COMERCIAL"
                      name="telefoneComercial"
                      className="form-control"
                      mask="(99) 9999-9999"
                      value={this.state.telefoneComercial}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label>Email *</label>
                    <input
                      placeholder="EMAIL"
                      name="email"
                      className="form-control"
                      value={this.state.email}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Telefone Celular</label>
                    <InputMask
                      placeholder="TELEFONE CELULAR"
                      name="telefoneCelular"
                      className="form-control"
                      mask="(99) \99999-9999"
                      value={this.state.telefoneCelular}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <label> </label>
                    <div className="form-check form-check-danger">
                      <label className="form-check-label">
                        <input
                          name="inativo"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.inativo}
                          onChange={this.handleChecked}
                        />
                        Inativo
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CadastroEndereco
          value={this.state.endereco}
          onChange={this.handleChangeEndereco}
        />
        <CadastroObservacao
          value={this.state.observacoes}
          onChange={this.handleChange}
        />
      </form >
    );
  }
}

export default CadastroEmpresa;
